import { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Tone, TONE_SOFT } from "./tones";

interface Props {
  tone: Tone;
  children: ReactNode;
  className?: string;
  role?: "alert" | "status";
}

/**
 * Inline tinted banner for inline errors, warnings and notes (Smartlead's
 * amber / purple info strips). One place for the padding/radius/text size
 * that was previously hand-assembled at every call site.
 */
export default function Alert({ tone, children, className, role }: Props) {
  return (
    <div role={role ?? (tone === "danger" ? "alert" : undefined)} className={cn("text-xs border rounded-lg px-3 py-2", TONE_SOFT[tone], className)}>
      {children}
    </div>
  );
}
